{
  "version": 1,
  "asset_id": "e578fadf-de31-4afa-815c-b0e034811e08",
  "project_id": "949ac23c-9e33-4376-b191-e19499cf4fa3",
  "url": "/__l5e/assets-v1/e578fadf-de31-4afa-815c-b0e034811e08/avcilar-hizli-elektrikci-7-24-dukkan-6.jpg",
  "r2_key": "a/v1/949ac23c-9e33-4376-b191-e19499cf4fa3/e578fadf-de31-4afa-815c-b0e034811e08/avcilar-hizli-elektrikci-7-24-dukkan-6.jpg",
  "original_filename": "avcilar-hizli-elektrikci-7-24-dukkan-6.jpg",
  "size": 585887,
  "content_type": "image/jpeg",
  "created_at": "2026-09-11T13:23:44Z"
}
